import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

const LAUNCH_ROUTES = new Set([
  'brand.launch',
  'admin.launch',
  'admin.launch.brand',
])

export const checkLaunchFeatureFlag: HermesGuardFn = async (to) => {
  if (!LAUNCH_ROUTES.has(to.name as string)) return undefined

  const featureFlags = useFeatureFlags()

  if (!featureFlags.isEnabled('hermes.launchDashboard')) {
    if (to.name === 'brand.launch') {
      return {
        name: 'brand.home',
        params: { brandId: to.params.brandId },
      }
    }
    return { name: 'brands' }
  }

  return undefined
}
